import React from "react";
import { TableHead, TableRow, TableCell } from "@mui/material";
import { useIntl } from "react-intl";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(theme => ({
  th: {
    padding: 7,
    fontSize: 10,
    color: theme.palette.primary.main,
    fontWeight: 600,
    textTransform: "uppercase",
    verticalAlign: "top",
    background: "#efefef",
  },
}));

const IncomingRequestsHeader = () => {
  const classes = useStyles();
  const intl = useIntl();

  const headers = [
    {
      name: "workspace",
      label: intl.formatMessage({
        id: "workspace.workspace",
      }),
    },
    {
      name: "status",
      label: intl.formatMessage({
        id: "product.date",
      }),
    },
    { name: "actions", label: "" },
  ];
  return (
    <TableHead>
      <TableRow>
        {headers.map(head => {
          return <TableCell className={classes.th}>{head.label}</TableCell>;
        })}
      </TableRow>
    </TableHead>
  );
};

export default IncomingRequestsHeader;
